import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { SupplierSchedule } from 'app/buffer-graph/models/suppliers-schedules/supplier-schedule';

type Data = { schedules: SupplierSchedule[] };
export class SuppliersSchedulesTabInfo extends TabInfoBase<Data> {
    constructor(data: Data) {
        super('OrdersSchedules', data);
    }

    get id(): string {
        return SuppliersSchedulesTabInfo.id;
    }

    static readonly id = 'SSS';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/suppliers-schedules/suppliers-schedules-tab-info.ts